import { ThemeOptions } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';

import { ThemeMode } from './types/types';

const sharedTheme = {
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiDivider: {
      styleOverrides: {
        vertical: {
          marginRight: 10,
          marginLeft: 10,
        },
      },
    },
  },
  typography: {
    fontFamily: '"Maven Pro", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2rem',
      '@media (min-width:600px)': { fontSize: '2.5rem' },
      '@media (min-width:960px)': { fontSize: '3rem' },
      '@media (min-width:1280px)': { fontSize: '3.25rem' },
      '@media (min-width:1920px)': { fontSize: '3.5rem' },
      '@media (min-width:2560px)': { fontSize: '4rem' },
      fontWeight: 500,
      lineHeight: 1.25,
    },
    h2: {
      fontSize: '1.5rem',
      '@media (min-width:600px)': { fontSize: '1.75rem' },
      '@media (min-width:960px)': { fontSize: '2rem' },
      '@media (min-width:1280px)': { fontSize: '2.25rem' },
      '@media (min-width:1920px)': { fontSize: '2.5rem' },
      '@media (min-width:2560px)': { fontSize: '2.75rem' },
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.25rem',
      '@media (min-width:600px)': { fontSize: '1.5rem' },
      '@media (min-width:960px)': { fontSize: '1.75rem' },
      '@media (min-width:1280px)': { fontSize: '2rem' },
      '@media (min-width:1920px)': { fontSize: '2.25rem' },
      '@media (min-width:2560px)': { fontSize: '2.5rem' },
      fontWeight: 500,
      lineHeight: 1.35,
    },
    h4: {
      fontSize: '1.125rem',
      '@media (min-width:600px)': { fontSize: '1.25rem' },
      '@media (min-width:960px)': { fontSize: '1.5rem' },
      '@media (min-width:1280px)': { fontSize: '1.75rem' },
      '@media (min-width:1920px)': { fontSize: '2rem' },
      '@media (min-width:2560px)': { fontSize: '2.25rem' },
      fontWeight: 500,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '1rem',
      '@media (min-width:600px)': { fontSize: '1.1rem' },
      '@media (min-width:960px)': { fontSize: '1.2rem' },
      '@media (min-width:1280px)': { fontSize: '1.25rem' },
      '@media (min-width:1920px)': { fontSize: '1.3rem' },
      '@media (min-width:2560px)': { fontSize: '1.4rem' },
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem',
      '@media (min-width:600px)': { fontSize: '1rem' },
      '@media (min-width:960px)': { fontSize: '1.1rem' },
      '@media (min-width:1280px)': { fontSize: '1.2rem' },
      '@media (min-width:1920px)': { fontSize: '1.25rem' },
      '@media (min-width:2560px)': { fontSize: '1.35rem' },
      fontWeight: 400,
      lineHeight: 1.45,
    },
    caption: {
      fontSize: '0.75rem',
      '@media (min-width:600px)': { fontSize: '0.875rem' },
      '@media (min-width:960px)': { fontSize: '1rem' },
      '@media (min-width:1280px)': { fontSize: '1.1rem' },
      '@media (min-width:1920px)': { fontSize: '1.2rem' },
      '@media (min-width:2560px)': { fontSize: '1.3rem' },
      fontWeight: 400,
      lineHeight: 1.6,
    },
  },
};

// to explore all the options, check out https://mui.com/material-ui/customization/default-theme/
const themes: Record<ThemeMode, ThemeOptions> = {
  light: deepmerge(sharedTheme, {
    palette: {
      mode: 'light',
      background: {
        default: '#fafafa',
        paper: '#fff',
      },
    },
  }),

  dark: deepmerge(sharedTheme, {
    palette: {
      mode: 'dark',
      background: {
        default: '#111',
        paper: '#171717',
      },
    },
  }),
};

export default themes;
